import {createAction, createReducer} from 'redux-act'
import { selector as configSelector } from '~/config'
import {all, select, apply, put, takeEvery} from 'redux-saga/effects'

import {Entity, handleError} from '~/utils/entity-utils'

import API from '~/api'
import {get} from "lodash";

const entityName = 'apiKey';
const entity = new Entity(entityName, API, configSelector);

// ACTIONS
export const actions = {
  ...entity.actions,
  refreshToken: {
    request: createAction('apiToken refresh request', (id) => ({id})),
    failure: createAction('apiToken refresh failure', (message) => ({message})),
    success: createAction('apiToken refresh success', (apiKey) => ({apiKey}))
  }
};

// WORKERS
export const workers = {
  ...entity.workers,
  * refreshToken(action) {
    const { id } = get(action, 'payload', {});
    if(id) {
      try {
        const config = yield select(configSelector);
        const api = new API(config);
        const response = yield apply(api, api.callRoute, [`api-keys/${id}/refresh_token/`, 'POST'])

        yield put(actions.refreshToken.success(response.data));
      } catch (e) {
        handleError(e, actions.refreshToken);
        throw e;
      }
    }
  }
};

// SAGA
export function * saga() {
  yield all([
    ...entity.saga,
    takeEvery(actions.refreshToken.request().type, workers.refreshToken)
  ]);
}

export const reducer = createReducer({
  ...entity.reducer,
  [actions.refreshToken.success]: (state, payload) =>  Object.assign({}, state, {[payload[entityName]['url']]: payload[entityName]}),
}, {});

export default {
  actions,
  workers,
  saga,
  reducer
}
